import { motion } from "framer-motion";
import { Bird, Brush, Check, Crown, Lock, PenLine, ScanFace, Type, Waves } from "lucide-react";

const LEVELS = [
  { n: 1, t: "Linee base", s: "Contorni puliti e costanti", state: "done", icon: PenLine },
  { n: 2, t: "Ombreggiatura", s: "Sfumature e pepper shading", state: "done", icon: Brush },
  { n: 3, t: "Lettering", s: "Script e gotico", state: "done", icon: Type },
  { n: 4, t: "Old School", s: "Rondine tradizionale", state: "current", icon: Bird },
  { n: 5, t: "Giapponese", s: "Serve 60 REP", state: "locked", icon: Waves },
  { n: 6, t: "Realistico", s: "Serve 120 REP", state: "locked", icon: ScanFace },
];

const Action = ({ state }) => {
  if (state === "done") return <span className="flex items-center gap-1 text-[8px] font-extrabold uppercase tracking-wider text-[#00E676]"><Check className="h-2.5 w-2.5" strokeWidth={3} /> Fatto</span>;
  if (state === "current") return <span className="rounded bg-[#E03A3A] px-2.5 py-1.5 text-[8px] font-extrabold uppercase tracking-wider text-white">Gioca</span>;
  return <Lock className="h-3 w-3 text-[#6B6B72]" />;
};

const Level = ({ n, t, s, state, icon: Icon, i }) => (
  <motion.li
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.15 + i * 0.07, duration: 0.45 }}
    className={`flex items-center gap-2.5 rounded-xl border bg-[#17171B] px-2.5 py-2 ${state === "current" ? "border-[#E03A3A]/70" : "border-[#2B2B31]"} ${state === "locked" ? "opacity-50" : ""}`}
  >
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#2B2B31] bg-[#0B0B0D]">
      <Icon className="h-3.5 w-3.5 text-[#E03A3A]" />
    </span>
    <span className="min-w-0 flex-1">
      <span className="block text-[10.5px] font-extrabold text-white">Livello {n} · {t}</span>
      <span className="block text-[8.5px] text-[#9A9AA0]">{s}</span>
    </span>
    <Action state={state} />
  </motion.li>
);

export const CampaignScreen = () => (
  <div className="flex h-full flex-col bg-[#0B0B0D] px-3.5 pb-16 pt-12 text-white" data-testid="app-screen-campagna">
    <p className="text-[8px] font-bold uppercase tracking-[0.3em] text-[#E03A3A]">Modalità carriera</p>
    <div className="mt-1 flex items-center justify-between">
      <p className="text-[22px] font-extrabold leading-none tracking-tight">Campagna</p>
      <span className="rounded-md border border-[#2B2B31] px-2 py-1 text-[10px] font-extrabold text-[#16E0F0]">434$</span>
    </div>
    <div className="mt-3 rounded-lg border border-[#2B2B31] px-2.5 py-2">
      <div className="flex items-center justify-between text-[8px] font-bold uppercase tracking-[0.18em]">
        <span className="flex items-center gap-1.5"><Crown className="h-2.5 w-2.5 text-[#9A9AA0]" /> Impara a tatuare</span>
        <span className="text-[#9A9AA0]">Liv. 4 / 12</span>
      </div>
      <div className="mt-2 h-1 rounded-full bg-[#2B2B31]"><div className="h-full w-[32%] rounded-full bg-[#BDBDC2]" /></div>
    </div>
    <p className="mt-4 text-[8px] font-bold uppercase tracking-[0.3em] text-[#9A9AA0]">Da apprendista a maestro</p>
    <ul className="mt-2 space-y-1.5">
      {LEVELS.map((l, i) => <Level key={l.n} {...l} i={i} />)}
    </ul>
  </div>
);
